import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-carousel-network-projects',
  templateUrl: './carousel-network-projects.component.html',
  styleUrls: ['./carousel-network-projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselNetworkProjectsComponent {
  @Input() public data: any[] = [];
}
